(function () {
    "use strict";

    // @ngInject
    function NetworkHelloLinkControllerCtor($scope, $injector, $modalInstance, NetworkManager, UsersManager,AnalyticsService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkHelloLinkController';

        this.modalInstance = $modalInstance;
        this.NetworkManager = NetworkManager;
        this.AnalyticsService = AnalyticsService;

        this.currUser = UsersManager.getCurrUser();
        AnalyticsService.trackPageView(this, AnalyticsService.analytics_events.network_unlock_hb_load);

    }

    Controllers.NetworkHelloLinkController = Class(Controllers.BaseController, {
        constructor: NetworkHelloLinkControllerCtor,

        cancelWorkflowLink: function cancelWorkflowLink(){
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_unlock_hb_cancel);

            this.modalInstance.close();
        },

        GotoPipelineLink: function GotoPipelineLink(){
            this.modalInstance.close();

            // update that it was unlocked
            this.NetworkManager.setUnlockHoneybook(this.currUser);

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_unlock_hb_confirm);
            this.goToState(this.AppStates.root_core_navigation_pipeline);

        }
    });
}());
